import { Modal } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, ClockCircleOutlined } from '@ant-design/icons';

const STATUS_CONFIG = {
  success: {
    icon: CheckCircleOutlined,
    iconColor: 'var(--positive)',
    title: 'Payment Successful!',
    description: 'Your payment has been completed successfully. Please close the above tab',
    buttonColor: 'green',
  },
  failure: {
    icon: CloseCircleOutlined,
    iconColor: 'var(--negative)',
    title: 'Payment Failed!',
    description: "We aren't able to process your payment. Please try again.",
    buttonColor: 'red',
  },
  pending: {
    icon: ClockCircleOutlined,
    iconColor: 'var(--primary-gold)',
    title: 'Payment Pending!',
    description: 'Your transaction is being processed and might take sometime. Please close the above tab',
    buttonColor: 'var(--primary-gold)',
  },
};

const MyGatewayStatusModal = ({ status = 'pending' }) => {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.pending;
  const StatusIcon = config.icon;

  // const closeWindow = () => {
  //   sessionStorage.clear();
  //   const attemptClose = () => {
  //     window.open('', '_self');
  //     window.close();
  //   };

  //   attemptClose();

  //   setTimeout(() => {
  //     if (!window.closed) {
  //       window.location.replace('about:blank');
  //       attemptClose();
  //     }
  //   }, 100);
  // };

  return (
    <Modal open={true} closable={false} centered style={{ maxWidth: '424px' }} footer={null}>
      <div style={{ display: 'flex', flexFlow: 'column wrap', alignItems: 'center' }}>
        <StatusIcon style={{ color: config.iconColor, fontSize: '60px', paddingBottom: '20px' }} />
        <span style={{ fontSize: 24 }}>{config.title}</span>
        <span style={{ fontSize: 14, paddingTop: 8, textAlign: 'center' }}>{config.description}</span>
      </div>
    </Modal>
  );
};

export default MyGatewayStatusModal;
